// @flow
import * as React from 'react';
import { featureIsEnabled } from '@ta/common.features';
import styles from './impressionPixels.less';

const PROFILE_DE = 'VisaDeutschland';
const PROFILE_FR = 'VisaFR';
const PROFILE_UK = 'Visa';

const POS_VAL_DE = 'nlsn161515';
const POS_VAL_FR = 'nlsn161514';
const POS_VAL_UK = 'nlsn160683';

const posValPerSpec = (profileName, pageName) => {
  const isTrips = pageName.indexOf('Trips') === 0;

  if (featureIsEnabled('visa_nielsen_tracking')) {
    if (featureIsEnabled('visa_nielsen_de') && (isTrips || profileName === PROFILE_DE)) {
      return POS_VAL_DE;
    }
    if (featureIsEnabled('visa_nielsen_fr') && (isTrips || profileName === PROFILE_FR)) {
      return POS_VAL_FR;
    }
    if (featureIsEnabled('visa_nielsen_uk') && (isTrips || profileName === PROFILE_UK)) {
      return POS_VAL_UK;
    }
  }
  return null;
};

export const getVisaNielsenPixel = (profileName: string, pageName: string) => {
  const posVal = posValPerSpec(profileName, pageName);
  if (posVal) {
    const ts = new Date().getTime();
    const owner = `nielsen_for_${profileName}`;
    const url = `https://secure-gl.imrworldwide.com/cgi-bin/m?ca=${posVal}&cr=crtve&ce=tripadvisor&pc=tripadvisor_plc0001&ci=nlsnci912&am=3&at=view&rt=banner&st=image&r=${ts.toString()}`;
    return (
      <img
        suppressHydrationWarning
        data-owner={owner}
        src={url}
        height="0"
        width="0"
        className={styles.impressionPixel}
      />
    );
  }
  return null;
};

export { getVisaNielsenPixel as default };
